import RootErrorBoundary from '@/components/layouts/RootErrorBoundary';
import RootLayout from '@/components/layouts/RootLayout';
import { protectedRoutes } from '@/routes/modules/protected-routes';
import { publicRoutes } from '@/routes/modules/public-routes';
import { createElement } from 'react';
import { createBrowserRouter, RouteObject } from 'react-router';

const routes: RouteObject[] = [
  {
    path: '/',
    element: createElement(RootLayout),
    errorElement: createElement(RootErrorBoundary),
    children: [...publicRoutes, ...protectedRoutes],
  },
];

export const router = createBrowserRouter(routes);
